import { RouteProp, useNavigation, useRoute } from '@react-navigation/core';
import { StackNavigationProp } from '@react-navigation/stack';
import React from 'react';
import styled from 'styled-components/native';
import Button from '../../components/Button';
import { H2, P } from '../../components/Typography';
import { StudiesParamList } from '../../navigation/StudiesNavigator';

const StyledView = styled.View`
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 64px 32px;
`;

const StyledContentView = styled.View`
  max-width: 420px;
  text-align: center;
`;

const StyledButton = styled(Button)`
  min-width: 180px;
  margin: 0 auto;
  margin-bottom: 32px;
`;

const StudyComingSoonScreen: React.FC = () => {
  const route = useRoute<RouteProp<StudiesParamList, 'StudyComingSoon'>>();
  const navigation = useNavigation<StackNavigationProp<any>>();
  return (
    <StyledView>
      <StyledContentView>
        <H2 padding={4} color='light' center>
          {route.params?.category} Study Coming Soon
        </H2>
        <P padding={4} color='light' center>
          This type of study is still being developed and will be available
          soon.
        </P>
        <StyledButton outlined size='medium' onPress={() => navigation.pop()}>
          Back
        </StyledButton>
      </StyledContentView>
    </StyledView>
  );
};

export default StudyComingSoonScreen;
